import { createContext, useContext } from '@wordpress/element';
export const ItemGroupContext = createContext({
  size: 'medium'
});
ItemGroupContext.displayName = 'ItemGroupContext';
export const useItemGroupContext = () => useContext(ItemGroupContext);